import {useEffect, useState} from 'react'
import {BooksitoutServer} from '../../../../config/BooksitoutServer'
import TopAuthorsResponse from '../responses/TopAuthorsResponse'

const useTopAuthors = () => {
	const [data, setData] = useState<TopAuthorsResponse | null>(null)
	const [isLoading, setIsLoading] = useState<boolean>(true)

	useEffect(() => {
		BooksitoutServer
			.get(`/v1/statistics/top-authors`)
			.then(res => setData(res.data))
			.finally(() => setIsLoading(false))
	}, [])

	return [data, isLoading] as const
}

export default useTopAuthors
